import React from "react";

interface DateIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const DateIcon: React.FC<DateIconProps> = ({ className, width = 40, height = 40 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 40 40" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect width="40" height="40" rx="20" fill="#FFE8F9"/>
      <path 
        d="M26.6665 12.4997H25.8332V10.833H24.1665V12.4997H15.8332V10.833H14.1665V12.4997H13.3332C12.4165 12.4997 11.6665 13.2497 11.6665 14.1663V27.4997C11.6665 28.4163 12.4165 29.1663 13.3332 29.1663H26.6665C27.5832 29.1663 28.3332 28.4163 28.3332 27.4997V14.1663C28.3332 13.2497 27.5832 12.4997 26.6665 12.4997ZM26.6665 27.4997H13.3332V18.333H26.6665V27.4997ZM26.6665 16.6663H13.3332V14.1663H26.6665V16.6663Z" 
        fill="#4F4A4A"
      />
    </svg>
  );
};

export default DateIcon;
